import React, { useEffect, useState } from "react";
import LoadingScreen from "../../Shared/LoadingScreen";
import Table from "../../Shared/Table";
import { PrimaryButton } from "../../Shared/Buttons";
import GetTransactions from "../../Store/Actions/GetTransaction-Action";
import { TransactionAction } from "../../Store/Reducers/Transaction-reducer";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { CustomerAction } from "../../Store/Reducers/Customer-reducer";
import ConfirmationModal from "../../Shared/ConfimationModal";
import LoadMoreItems from "../../Shared/LoadMoreItemsScreen";
import { useErrorHandler } from "react-error-boundary";
import SearchComp from "../../Shared/GlobalSearch";
import styles from "./styles.module.css";

const TransactionComp = () => {
  const dispatch = useDispatch();

  const {
    TransactionData,
    loading,
    isLoaded,
    lastEvaluatedkey,
    searchData,
    showSearch,
    loadMore,
    status,
  } = useSelector((state) => state.Transaction);
  const { customerData: customerDataList } = useSelector(
    (state) => state.Customer
  );
  const ErrorHandler = useErrorHandler();
  const [isOpen, setIsOpen] = useState({
    open: false,
  });
  const [phoneNumber, setPhoneNumber] = useState("");
  const [blockNumber, setBlockNumber] = useState({ phoneNumber: "" });

  useEffect(() => {
    dispatch(TransactionAction.setShowSearch(false));
    if (!isLoaded) {
      dispatch(GetTransactions(lastEvaluatedkey));
      dispatch(TransactionAction.setIsLoaded(true));
    }
  }, [isLoaded]);

  useEffect(() => {
    if (status !== "") {
      ErrorHandler(() => {
        throw new Error(status);
      });
    }
  }, [status]);

  const blockUser = async (phoneNo) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_URL}customer/block`,
        {
          phone_number: phoneNo,
        }
      );
      if(res.status === 200){
        setBlockNumber({ phoneNumber: phoneNo });
      }
    } catch (error) {
      if (error.message) {
        throw new Error(error.message);
      }
    }
  };

  let editedCustomer;
  let newCustomersList = [...customerDataList];
  const transactionUserBlock = async (phoneNo) => {
    // let currCustonerIndex = "";
    customerDataList.map((item, index) => {
      if (item.number === phoneNo) {
        editedCustomer = {
          ...newCustomersList[index],
          enabled: false,
        };
        newCustomersList[index] = editedCustomer;
      }
    });
    await blockUser(phoneNo);
    dispatch(CustomerAction.setCustomerList(newCustomersList));
  };
  const getTime = (key) => {
    return (
      new Date(key).toDateString() +
      " " +
      new Date(key).getHours() +
      ":" +
      new Date(key).getMinutes() +
      ":" +
      new Date(key).getSeconds()
    );
  };
  const formatData = (data) => {
    let formattedData = data.map((item) => ({
      Customer_Name: item.name ? item.name : "—",
      transaction_id: item.transaction_id ? item.transaction_id : "—",
      GTransactionID:
        typeof item.id === "string" && item.id.length > 0
          ? parseInt(item.id)
          : "—",
      Phone_No: item?.cart_data ? item?.cart_data?.cartDetail?.mobile_no : "—",
      Cart_Total: item.amount ? parseFloat(item.amount) : "—",
      card_number: item.card_number ? item.card_number : "—",
      tStatus: item.msg ? item.msg : "—",
      action: item.gateway_action ? item.gateway_action : "—",
      gMessage: item.msg ? item?.msg : "—",
      gStatus: item.status ? item?.status : "—",
      transTime: item.created_at ? getTime(item.created_at) : "—",
      UserActions: (
        <PrimaryButton
          type="danger"
          size="large"
          testId={`block_user_${item.id}`}
          disabled={
            item.cart_data
              ? blockNumber.phoneNumber !==
                item?.cart_data.cartDetail?.mobile_no
                ? item?.customer_status?.Enabled
                  ? false
                  : true
                : true
              : true
          }
          handleClick={() => {
            setPhoneNumber(item?.cart_data.cartDetail?.mobile_no);
            setIsOpen({ open: true });
          }}
        >
          Block
        </PrimaryButton>
      ),
    }));
    return formattedData;
  };
  const columns = [
    {
      name: "Customer_Name",
      label: "Customer Name",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "action",
      label: "Action",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "GTransactionID",
      label: "Gateway Transaction ID",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "transaction_id",
      label: "Transaction ID",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "tStatus",
      label: "Status",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "gStatus",
      label: "Gateway Status",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "gMessage",
      label: "Gateway Message",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "transTime",
      label: "Transaction Time",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "card_number",
      label: "Card Number",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "Phone_No",
      label: "Phone No",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "Cart_Total",
      label: "Cart Total",
      options: {
        sort: true,
        filter: true,
      },
    },
    {
      name: "UserActions",
      label: "UserActions",
      options: {
        sort: true,
        filter: true,
      },
    },
  ];
  const onTableChangeHandler = (action, tableState) => {
    const { page, rowsPerPage, data } = tableState;
    let diff = Math.abs(page * rowsPerPage - data.length);
    if (
      diff <= rowsPerPage &&
      !showSearch &&
      lastEvaluatedkey.transaction_id &&
      (action === "changePage" || action === "changeRowsPerPage")
    ) {
      dispatch(GetTransactions(lastEvaluatedkey));
      return;
    }
  };

  return (
    <>
      {loading ? (
        <LoadingScreen loading={loading} />
      ) : (
        <>
          {loadMore && <LoadMoreItems loading={loadMore} />}
          <div className={styles.searchDiv}>
            <SearchComp
              endpoint={"transaction/search?card"}
              caller={"transaction"}
              options={false}
            />
          </div>
          <Table
            data={
              showSearch ? formatData(searchData) : formatData(TransactionData)
            }
            columns={columns}
            title="Transactions"
            onTableChange={onTableChangeHandler}
          />
          {isOpen.open && (
            <ConfirmationModal
              open={isOpen.open}
              content="Are you sure you want to block this user ?"
              // item={isOpen.item}
              deleteHandler={() => {
                transactionUserBlock(phoneNumber);
              }}
              setIsopen={setIsOpen}
              buttonName={"Block"}
            />
          )}
        </>
      )}
    </>
  );
};

export default TransactionComp;
